import { CHECK_LOGIN, LOGIN_USER_SUCCESSFUL, API_ERROR, LOGOUT_USER, LOGOUT_USER_SUCCESS, VERIFY_ADMIN_SUCCESS, VERIFY_ADMIN_FAIL, RESET_STATE, REQUEST_OTP_USER_SUCCESS, REQUEST_OTP_USER_FAIL, RESET_ACTION_STATE, SWITCH_USER_SUCCESS, SWITCH_USER_FAIL } from './actionTypes';

const initialState = {
    loginError: "", message: null, loading: false, verifyAdmin: [], requestOtp: [], loginRes: [], switchUserRes: []
}
const login = (state = initialState, action) => {
    switch (action.type) {
        case CHECK_LOGIN:
            state = {
                ...state,
                loading: true
            }
            break;
        case LOGIN_USER_SUCCESSFUL:
            state = {
                ...state,
                loading: false,
                loginRes: action.payload,
            }
            break;

        case REQUEST_OTP_USER_SUCCESS:
            state = {
                ...state,
                requestOtp: action.payload,
            }
            break;
        case REQUEST_OTP_USER_FAIL:
            state = {
                ...state,
                loginError: action.payload,
                requestOtp: action.payload,
            }
            break;

        case SWITCH_USER_SUCCESS: {
            const switchedUser = action.payload?.user?.data
                ? action.payload.user
                : action.payload?.data
                    ? action.payload
                    : null;
            state = {
                ...state,
                switchUserRes: action.payload,
                ...(switchedUser && {
                    verifyAdmin: switchedUser,
                    permissionArry: switchedUser?.data?.permissions,
                }),
            }
            break;
        }
        case SWITCH_USER_FAIL:
            state = {
                ...state,
                error: action.payload,
                switchUserRes: action.payload,
            }
            break;

        case LOGOUT_USER:
            state = { ...state };
            break;

        case LOGOUT_USER_SUCCESS:
            state = { ...state };
            break;

        case API_ERROR:
            state = {
                ...state,
                loading: false,
                loginError: action.payload
            }
            break;
        case VERIFY_ADMIN_SUCCESS:
            state = {
                ...state,
                loading: true,
                verifyAdmin: action.payload,
                permissionArry: action.payload && action.payload.user && action.payload.user.data && action.payload.user.data.permissions
            }
            break;
        case VERIFY_ADMIN_FAIL:
            state = {
                ...state,
                loading: true,
                verifyAdmin: action.payload,
            }
            break;
        case RESET_ACTION_STATE:
            state = {
                ...state,
                requestOtp: [],
                switchUserRes: [],
            };
            break;

        case RESET_STATE:
            state = initialState;
            break;

        default:
            state = { ...state };
            break;
    }
    return state;
}

export default login;
